import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import { Fragment } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { defineStyles } from '../theme';
import AddAndFilterButton from './buttons/AddAndFilterButton';
import { ApplyFiltersButton } from './buttons/ApplyFiltersButton';
import { FilterAndCondition } from './FilterAndCondition';
import { AndChip } from './FilterLogicChips';
const styles = defineStyles({
    conditionsAndButton: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        columnGap: 2,
    },
    inlineActions: {
        display: 'flex',
        flexDirection: 'column',
        rowGap: 1,
    },
});
export function FilteringFormConditionsContent({ filterColumns, enableAutocomplete, showApplyButton = false, applyFilters = () => { }, }) {
    const form = useFormContext();
    const { control } = form;
    const { append, fields, remove } = useFieldArray({
        name: 'andConditions',
        control,
        shouldUnregister: false,
    });
    const isValid = form.formState.isValid;
    const isDirty = form.formState.isDirty;
    const isApplyFiltersDisabled = !isDirty || !isValid;
    return (_jsxs(Box, { sx: styles.conditionsAndButton, children: [fields.map((field, index) => (_jsxs(Fragment, { children: [_jsx(FilterAndCondition, { enableAutocomplete: enableAutocomplete, field: field, canRemoveAndBlock: fields.length > 1, removeParent: () => remove(index), andConditionsIndex: index, filterColumns: filterColumns }), index < fields.length - 1 && _jsx(AndChip, {})] }, field.id))), fields.length > 0 && (_jsxs(Box, { sx: styles.inlineActions, children: [_jsx(AddAndFilterButton, { disabled: !isValid, append: append, fieldsCount: fields.length, applyFilters: applyFilters }), showApplyButton && fields.some((field) => !field.fixed) && (_jsx(ApplyFiltersButton, { disabled: isApplyFiltersDisabled }))] }))] }));
}
//# sourceMappingURL=FilteringFormConditionsContent.js.map